import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { authClient } from "@core/clients";
import { User } from "@core/types";

const useAuthByTelegram = (token: string, options?: UseQueryOptions<User | { customer_confirmed: false }>) =>
  useQuery({
    queryKey: ["auth-by-telegram", token],
    queryFn: async () => {
      const data = await authClient.authByTGToken(token);

      return data;
    },
    ...options
  });

export default useAuthByTelegram;
